const Toggle = (()=>{

    const _ToggleConfig = ()=>{
        const toggle = document.querySelectorAll('.toggle');

        toggle.forEach((item, indice)=>{
            //Enable first element
            const firtsChild = item.querySelector('.toggle__hero');
            indice > 0 ? (item.style.maxHeight = `${firtsChild.scrollHeight}px`) : (item.style.maxHeight = `${item.scrollHeight}px`, item.classList.add('active'));
            //Enable clicked elements
            item.addEventListener('click', ()=>{
                toggle.forEach((itemNested)=>{
                    itemNested.classList.remove('active');
                    itemNested.style.maxHeight = `${itemNested.querySelector('.toggle__hero').scrollHeight}px`
                });
                //Enable element
                item.classList.add('active');
                item.style.maxHeight = `${item.scrollHeight}px`;
                //Anchor to element
                setTimeout(()=>{
                    window.scrollTo({
                        top: item.offsetTop + 100,
                        behavior: "smooth"
                    });
                },500)
            });
        });
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _ToggleConfig(); } catch (error) { console.log(error) }
        }
    }
})();

/*
*Load global functions
*/
const loadToggleHandlers = ()=>{
    Toggle.setHandleEvent();
}

export { loadToggleHandlers }